
import './loader.css';
function Loading() {
    return (
        <div className="loader">
        <div className="custom-loading-color" >
        <span className="k-loading-text" >Loading</span>
        <div className="k-loading-image " style={{width:"40px" , height:"40px", position:"relative",color:"blue",}} ></div>
        <div className="k-loading-color"   style={{top:"-30px",left:"10px", position:"relative",color:"blue",}}></div>
      </div>
      </div>
    )
}
export default Loading;



